import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function upiValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null; // No error if the control is empty
        }

        // UPI format: `username@bank`
        const upiRegex = /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/;

        return !upiRegex.test(control.value) ? { invalidUPI: true } : null;
    };
}
